import type { ButtonProps } from '@sravni/react-design-system/lib/Button';
import { Button } from '@sravni/react-design-system/lib/Button';
import { Link } from '@sravni/react-design-system/lib/Typography';

import type { TButtonFlow, TOnClickFlow } from 'commonTypes/api/scenarios/BaseTypes';

type VerificationInstructionsButtonProps = Omit<ButtonProps, 'variant' | 'onClick' | 'children'> & {
  button: TButtonFlow<TOnClickFlow>;
};

export const VerificationInstructionsButton = (props: VerificationInstructionsButtonProps) => {
  const { button, ...rest } = props;
  const { onClick } = button;

  return (
    <Link
      href={onClick.action?.redirectUrl}
      target={onClick.type === 'externalRedirect' ? '_blank' : undefined}
      rel={onClick.type === 'externalRedirect' ? 'noopener,noreferrer' : undefined}
    >
      <Button
        {...rest}
        variant={button.type}
      >
        {button.title}
      </Button>
    </Link>
  );
};
